export default "/_next/static/images/69ea28493c3a2d868cfbddcf3add6013.png";